import _ from "lodash";
import React, { useEffect, useState } from "react";
import "./styles.scss";

export default function CustomSidePanel({ show, moduleName, handleClose, title, children, showPreviosButton, showNextButton, onNextClick, onPreviousClick, customStyles }) {
  const [styles, setStyles] = useState({
    width: "80vw",
    right: "81vw",
  });

  useEffect(() => {
    if (!_.isEmpty(customStyles)) {
      if (customStyles.width && customStyles.right) {
        setStyles(customStyles);
      }
    }
  }, [customStyles]);

  const getTitleWidth = (moduleName) => {
    if (typeof moduleName === "string") {
      return `${moduleName.length * 10}px`;
    }
    return "76px";
  };
  return (
    <div className="custom-side-pannel-container">
      {show && <div className="custom-side-pannel-blank-bg" onClick={handleClose}></div>}
      {show && (
        <>
          {" "}
          <div id="floatarrow" className="px-1 p-1 gap-2 d-flex flex-column offcanvas offcanvas-right mt-2 csp-float-arrow-button shadow-none" style={{ right: show ? styles.right : "-10vw", height: "fit-content" }}>
            <div className="csp-button-wrapper">
              <span onClick={handleClose} className="btn btn-xs btn-icon cursor-pointer">
                <i className="fas fa-times float-color "></i>
              </span>
            </div>
            <div className=" csp-button-wrapper2">
              {(showPreviosButton || showNextButton) && (
                <span onClick={() => (showPreviosButton ? onPreviousClick(showPreviosButton) : {})} className={`btn btn-xs btn-icon ${showPreviosButton ? "cursor-pointer" : "cursor-not-allowed"} `}>
                  <i className={`fas fa-angle-up ${showPreviosButton ? "float-color" : ""}`}></i>
                </span>
              )}
              <span className="csp-module-name" style={{ height: getTitleWidth(moduleName) }}>
                {moduleName}
              </span>
              {(showPreviosButton || showNextButton) && (
                <span onClick={() => (showNextButton ? onNextClick(showNextButton) : {})} className={`btn btn-xs btn-icon ${showNextButton ? "cursor-pointer" : "cursor-not-allowed"} `}>
                  <i className={`fas fa-angle-down ${showNextButton ? "float-color" : ""}`}></i>
                </span>
              )}
            </div>
          </div>
          <div
            id="sidepanel"
            style={{
              right: show ? 0 : `-${styles.width}`,
              width: styles.width,
              height: "100vh",
            }}
            className={"offcanvas offcanvas-right pb-10 "}
          >
            <div className="card shadow-none rounded-0" style={{ height: "calc(100vh)", overflowY: "auto" }}>
              {children}
            </div>
          </div>

          {/* <div
            id="sidepanel"
            style={{
              right: show ? 0 : `-${styles.width}`,
              width: styles.width,
              height: "100vh",
            }}
            className={"offcanvas offcanvas-right pb-10 "}
          >
            <div className="card shadow-none rounded-0" style={{ height: "calc(100vh)", overflowY: "auto" }}>
              {title && (
                <div className="card-header d-flex flex-stack align-items-center">
                  <h3 className="card-title fw-bolder text-dark">{title}</h3>
                </div>
              )}
              <div
                style={{
                  height: "calc(100vh - 70px)",
                  overflowY: "auto",
                }}
                className="card-body"
              >
                {children}
              </div>
            </div>
          </div> */}
        </>
      )}
    </div>
  );
}
